import type { ComponentPropsWithoutRef, ReactNode } from "react";
import { cn } from "../../utils/cn";

type DSBadgeVariant = "primary" | "disabled";

type DSBadgeProps = {
  children: ReactNode;
  variant?: DSBadgeVariant;
} & ComponentPropsWithoutRef<"span">;

const variantClassByName: Record<DSBadgeVariant, string> = {
  disabled: "bg-gray-3 text-dark-1",
  primary: "bg-brand-primary-3-20 text-brand-primary-3",
};

function DSBadge({ children, className, variant = "primary", ...props }: DSBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex px-2 py-1 min-w-8 min-h-8 shrink-0 items-center justify-center rounded-[1000px] text-[16px] font-inter font-semibold leading-[normal] tracking-[0px]",
        variantClassByName[variant],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}

export { DSBadge };
export type { DSBadgeProps, DSBadgeVariant };
